module.exports = __webpack_public_path__ + "files/745377f31aecf0f659e0f2830590b504.svg";